import "./footer.css";
import { FaGithubSquare } from 'react-icons/fa';
import { BsLinkedin } from 'react-icons/bs';
import { SiLeetcode } from "react-icons/si";
import { SiGeeksforgeeks } from "react-icons/si";


function Footer(){
    return (
        <footer id="footer">
            <a href="" className="footer__logo">AKB</a>

            {/* <ul className="parmalinks">
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Experience</a></li>
                <li><a href="#portfolio">Portfolio</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul> */}


            <div className="footer__socials">
                <a href="https://github.com/Akb98443" target="_blank" title="My Github"><FaGithubSquare /></a>
                <a href="https://www.linkedin.com/in/akb98443/" target="_blank" title="My Linkedin Profile"><BsLinkedin /></a>
                <a href="https://leetcode.com/u/jems1123/" target="_blank" title="My leetcode Profile"> <SiLeetcode/></a>
                <a href="https://www.geeksforgeeks.org/user/avanish6745/" target="_blank" title="My GFG Profile"> <SiGeeksforgeeks /></a>


            </div>
            <div className="footer__copyright">
                <small>&copy; AKB All rights reserved</small>
            </div>
        </footer>
    
        )
}
export default Footer;